import { Resume as ResumeWebsite } from "pages/web/customReports/subpages/resume/Resume";
import { Resume as ResumeMobile } from "pages/mobile/customReports/subpages/resume/Resume";
import { Reports as ReportsWebsite } from "pages/web/customReports/subpages/reports/Reports";
import { TemplateReport as TemplateReportsMobile } from "pages/web/customReports/subpages/reports/TemplateReport";
import { TemplateReport as TemplateReportsWebsite } from "pages/web/customReports/subpages/reports/TemplateReport";
import { Reports as ReportsMobile } from "pages/mobile/customReports/subpages/reports/Reports";
import { Category as CategoryWebsite } from "pages/web/customReports/subpages/category/Category";
import { Category as CategoryMobile } from "pages/mobile/customReports/subpages/category/Category";
import { ExecuteReport as ExecuteReportMobile } from "pages/mobile/customReports/subpages/execute_report/ExecuteReport";
import { ExecuteReport as ExecuteReportWebsite } from "pages/web/customReports/subpages/execute_report/ExecuteReport";


export const gettingSubPage = (subPage, mobile, location) => {
	switch (subPage) {
		case "resume":
			return mobile ? <ResumeMobile /> : <ResumeWebsite />;

		case "report_configurations":
			return mobile ? <ReportsMobile /> : <ReportsWebsite />;

		case "category":
			return mobile ? <CategoryMobile /> : <CategoryWebsite />;

		case "execute_reports":
			return mobile ? <ExecuteReportMobile /> : <ExecuteReportWebsite />;

		case "template":
			const queryParams = new URLSearchParams(location.search);
			const report_id = parseInt(queryParams.get("report_id"));
			return mobile ? (
				<TemplateReportsMobile report_id={report_id} />
			) : (
				<TemplateReportsWebsite report_id={report_id} />
			);

		default:
			return <> {`404 Subpage ${subPage} not found`} </>;
	}
};